export enum LOADING_SAVED_QUOTATIONS_STATES {
  INIT_LOADING = "INIT_LOADING",
  STEP_ONE_SERVICES_LOADING = "STEP_ONE_SERVICES_LOADING",
  STEP_ONE_SERVICES_LOADED = "STEP_ONE_SERVICES_LOADED",
  STEP_ONE_DATA_FILLING = "STEP_ONE_DATA_FILLING",
  STEP_ONE_DATA_FILLED = "STEP_ONE_DATA_FILLED",
  STEP_TWO_SERVICES_LOADING = "STEP_TWO_SERVICES_LOADING",
  STEP_TWO_SERVICES_LOADED = "STEP_TWO_SERVICES_LOADED",
  STEP_TWO_DATA_FILLING = "STEP_TWO_DATA_FILLING",
  STEP_TWO_DATA_FILLED = "STEP_TWO_DATA_FILLED",
  STEP_THREE_SERVICES_LOADING = "STEP_THREE_SERVICES_LOADING",
  STEP_THREE_SERVICES_LOADED = "STEP_THREE_SERVICES_LOADED",
  STEP_THREE_DATA_FILLING = "STEP_THREE_DATA_FILLING",
  STEP_THREE_DATA_FILLED = "STEP_THREE_DATA_FILLED",
  STEP_FOUR_SERVICES_LOADING = "STEP_FOUR_SERVICES_LOADING",
  STEP_FOUR_SERVICES_LOADED = "STEP_FOUR_SERVICES_LOADED",
  STEP_FOUR_DATA_FILLING = "STEP_FOUR_DATA_FILLING",
  STEP_FOUR_DATA_FILLED = "STEP_FOUR_DATA_FILLED",
  HAS_ERROR = "HAS_ERROR",
  FINISH_LOADING = "FINISH_LOADING",
}
